import {createAxios} from './createAxios';

export const loginApiClient = createAxios(process.env.REACT_APP_LOGIN_API_URL as string);
